export default "__VITE_ASSET__BqYhSuwx__"